import React from "react";
import { Badge2 } from "@/ui2/atoms/Badge";

import { getAppointmentFromDate, getTodaysDate } from "./helpers";

export const TodaysDateBadge = () => {
  const date = getTodaysDate();
  const appointmentDate = getAppointmentFromDate(date);

  return (
    <div className="tw:flex tw:gap-1 tw:flex-col tw:lg:flex-row tw:lg:items-center tw:order-1 tw:lg:order-none">
      <span className="tw:text-text-tertiary body-xs tw:mr-1">Today&apos;s Date:</span>

      <Badge2 className="tw:whitespace-nowrap">
        <time
          dateTime={date.toISOString()}
        >{`${appointmentDate.day_of_week}, ${appointmentDate.month_of_year} ${appointmentDate.day}, ${appointmentDate.year}`}</time>
      </Badge2>
    </div>
  );
};
